import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import "./Header.css";
import logo from "../../assets/logos/PizzaMax_Logo.png";

function Header() {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(!!localStorage.getItem("token"));
  const [isScrolled, setIsScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = () => {
      setIsLoggedIn(!!localStorage.getItem("token"));
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleLogout = async () => {
    const token = localStorage.getItem("token");

    if (!token) {
      setIsLoggedIn(false);
      navigate("/");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_SOCKET_URL}/api/auth/logout`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.ok) {
        localStorage.removeItem("token");
        setIsLoggedIn(false);
        window.dispatchEvent(new Event("storage"));
        navigate("/");
      } else {
        console.error("Logout failed:", response.statusText);
      }
    } catch (error) {
      console.error("Error logging out:", error);
    }
  };

  return (
    <header className={`headerarea ${isScrolled ? "fix" : ""}`}>
      <div className="container">
        <div className="header-body d-flex align-items-end justify-content-between">
          <div className="logo">
            <Link to="/" className="nav-link">
              <img src={logo} alt="logo" />
            </Link>
          </div>
          <div className="header-right d-flex align-items-center justify-content-between">
            <nav className="menu">
              <div
                className={`menuButton ${isOpen ? "arrow_change" : ""}`}
                onClick={() => setIsOpen(!isOpen)}
              >
                <span></span>
                <span></span>
                <span></span>
              </div>

              <ul className={isOpen ? "nav-menu open" : "nav-menu"}>
              <li>
                  <Link to="/" className="nav-link" onClick={() => setIsOpen(false)}>
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="nav-link" onClick={() => setIsOpen(false)}>
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="nav-link" onClick={() => setIsOpen(false)}>
                    Contact Us
                  </Link>
                </li>
                {isLoggedIn && (
                  <li>
                    <Link to="/dashboard" className="nav-link" onClick={() => setIsOpen(false)}>
                      Dashboard
                    </Link>
                  </li>
                )}
              </ul>



              {/* <ul className={isOpen ? "open" : ""}>
                <li>
                  <Link to="/" className="nav-link">
                    Home
                  </Link>
                </li>
                <li>
                  <Link to="/about" className="nav-link">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/contact" className="nav-link">
                    Contact Us
                  </Link>
                </li>
                {isLoggedIn && (
                  <li>
                    <Link to="/dashboard" className="nav-link">
                      Dashboard
                    </Link>
                  </li>
                )}
              </ul> */}
            </nav>
            <div className="cartgroup d-flex align-items-center">
              {!isLoggedIn ? (
                <Link to="/login" className="btn-login">
                  <span>
                    <img src={require("../../assets/pizzamax/usericon.webp")} alt="user" />
                  </span>
                  login
                </Link>
              ) : (
                <button className="logout-button" onClick={handleLogout}>
                  Logout
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}

export default Header;
